import React from 'react';
import { ImageLogo } from "../../Styles/ImageLogo/ImageLogoStyle"

const LogoBank = ({marginTop, marginBottom}) => <ImageLogo marginTop={marginTop} marginBottom={marginBottom}/>
  
export default LogoBank;